// Configuration for external website integration

export const EXTERNAL_CONFIG = {
  // Replace this with your other website's URL
  EXTERNAL_WEBSITE_URL: process.env.REACT_APP_EXTERNAL_WEBSITE_URL || 'https://user.ritzprimego.pro',
  
  // Authentication settings
  AUTH: {
    TOKEN_KEY: 'userToken',
    USER_DATA_KEY: 'userData',
    TOKEN_EXPIRY: 86400, // 24 hours in seconds
    COOKIE_OPTIONS: 'path=/; max-age=86400; SameSite=None; Secure'
  },
  
  // Redirect settings
  REDIRECT: {
    SUCCESS_DELAY: 2000, // 2 seconds
    ERROR_DELAY: 5000    // 5 seconds
  }
};

// Function to get the external website URL
export const getExternalWebsiteUrl = () => {
  const url = EXTERNAL_CONFIG.EXTERNAL_WEBSITE_URL;
  console.log('getExternalWebsiteUrl called, returning:', url);
  console.log('Environment variable REACT_APP_EXTERNAL_WEBSITE_URL:', process.env.REACT_APP_EXTERNAL_WEBSITE_URL);
  return url;
};

// Function to update the external website URL
export const setExternalWebsiteUrl = (url) => {
  EXTERNAL_CONFIG.EXTERNAL_WEBSITE_URL = url;
};
